export default __webpack_public_path__ + "static/media/iphoneAuthyApp.1a5976a0.svg";